import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { Button, Card, Col, Container, Row } from "reactstrap"
import InfoMeAction from "store/me-resource/actions"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TabAttendanceManagement from "./TabAttendanceManagement"
import TabEngraving from "./TabEngraving"
import TabEngravingHistory from "./TabEngravingHistory"

const Dashboard = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)

  const [isActiveTab, setIsActiveTab] = useState({
    id: 1,
    item: "（一般従業員）勤怠管理、打刻",
  })

  React.useEffect(() => {
    dispatch(InfoMeAction.getInfoMe())
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"勤怠管理"} breadcrumbList={[]} />
          <Row>
            <Col
              sm="6"
              className="d-flex align-items-center justify-content-center"
            >
              <Button
                className={[
                  "w-100 rounded-0 border",
                  isActiveTab.id === 1 ? "button-active" : "button",
                ].join(" ")}
                onClick={() =>
                  setIsActiveTab({
                    id: 1,
                    item: "（管理者）勤怠管理、打刻",
                  })
                }
              >
                打刻
              </Button>
              <Button
                className={[
                  "w-100 rounded-0 border",
                  isActiveTab.id === 2 ? "button-active" : "button",
                ].join(" ")}
                onClick={() =>
                  setIsActiveTab({
                    id: 2,
                    item: "（管理者）勤怠管理、打刻",
                  })
                }
              >
                打刻履歴
              </Button>

              {store.infoMe.data.data?.authority != "一般" && (
                <Button
                  className={[
                    "w-100 rounded-0 border",
                    isActiveTab.id === 3 ? "button-active" : "button",
                  ].join(" ")}
                  onClick={() =>
                    setIsActiveTab({
                      id: 3,
                      item: "（管理者）勤怠管理、打刻",
                    })
                  }
                >
                  勤怠管理
                </Button>
              )}
            </Col>
          </Row>
          {isActiveTab.id === 1 ? (
            <TabEngraving />
          ) : isActiveTab.id === 2 ? (
            <TabEngravingHistory />
          ) : (
            <TabAttendanceManagement />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
